import { FC } from 'react'
import styled from 'styled-components'
import { H1 } from '@/components/atoms/typography'
import { Box } from '@/components/atoms/Grid'
import Link from '@/components/atoms/link'
import { Manufacturer as ManufacturerModel } from '@/network/graphql.g'
import { validFor } from '@/theme/validFor'

type ManufacturerListProps = {
  manufacturersList: Record<string, ManufacturerModel[]>
}

const ManufacturerList: FC<ManufacturerListProps> = ({ manufacturersList }) => {
  const groups = Object.keys(manufacturersList)

  return (
    <Box>
      {groups.map((group) => (
        <StyledSection key={group}>
          <Anchor id={group.replace(/\s/g, '')} />
          <StyledH1>{group}</StyledH1>
          <ManufacturerGrid>
            {manufacturersList[group]?.map((item) => (
              <ManufacturerItem key={item.id} href={item.link}>
                <ManufacturerName bold={item.bold}>
                  {item.name}
                </ManufacturerName>
                <ManufacturerCount>
                  {item.count ? item.count : 1}
                </ManufacturerCount>
              </ManufacturerItem>
            ))}
          </ManufacturerGrid>
        </StyledSection>
      ))}
    </Box>
  )
}

export default ManufacturerList

const StyledSection = styled.div`
  position: relative;
  ${validFor.mobile`
    margin: auto -10px;
    `}
`

const Anchor = styled.span`
  position: absolute;
  top: -74px;
`

const StyledH1 = styled(H1)`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  background-color: ${(props) => props.theme.colors.navMenuGrey};
  padding: 8px 16px;
  ${validFor.mobile`
      padding: 8px 15px;
    `}
`

const ManufacturerGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ManufacturerItem = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  text-decoration: none;
  color: inherit;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f9f9f9;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors.navMenuGrey};
  }
`

const ManufacturerName = styled.span<{ bold?: boolean }>`
  font-size: 14px;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  opacity: ${(props) => (props.bold ? 1 : 0.8)};
  letter-spacing: -1px;
`

const ManufacturerCount = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors.infoSecondary};
  margin-left: auto;
  background: ${(props) => props.theme.colors.navMenuGrey};
  padding: 4px;
  border-radius: 4px;
`
